function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.937 4.843v6.611c0 1.306-.956 2.469-2.256 2.594a2.499 2.499 0 0 1-2.744-2.488V3.837c0-.819.588-1.563 1.4-1.644A1.562 1.562 0 0 1 9.062 3.75v6.562a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625V4.843a.472.472 0 0 0-.469-.469.472.472 0 0 0-.468.469v5.38c0 .819.587 1.563 1.4 1.644a1.562 1.562 0 0 0 1.724-1.556V3.855c0-1.306-.956-2.468-2.256-2.593A2.495 2.495 0 0 0 5 3.749v7.668c0 1.793 1.312 3.4 3.1 3.568a3.44 3.44 0 0 0 3.774-3.425V4.843a.472.472 0 0 0-.469-.469.472.472 0 0 0-.468.469z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/attachment.d5bd652f.svg";
export { SvgComponent as ReactComponent };